import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

/**
 * CAT-Q patient self-report form entrypoint.
 *
 * We pass `formKey="catq"` explicitly so we always bind to the correct Firestore
 * form definition, even if titles change or other instruments have similar names.
 */
export default function PatientCATQForm() {
  return (
    <PatientFormTemplate
      formTitle="Camouflaging Autistic Traits Questionnaire (CAT-Q)"
      formKey="catq"
    />
  );
}

